package com.example.mystybag.appCore.expected

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel

/**
 * JS actual: returns `false` so the caller falls through to the regular
 * Compose card path. The previous implementation rendered the card as a
 * native DOM `<div>` on a separate overlay because the cover image had
 * to live in DOM (CORS workaround). Now that Coil paints the cover
 * straight on the Skiko canvas, there is no reason to escape into DOM
 * for the card chrome either — Compose handles it on every platform.
 */
@Composable
actual fun WebHomeTopPickCardOverlay(
    model: HomeTopPickUiModel,
    modifier: Modifier,
    enabled: Boolean,
    onClick: () -> Unit,
    onFavouriteClick: () -> Unit
): Boolean = false
